var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhirlpoolStepperReviewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 14.75H2.75V28.75C2.75 29.2804 2.96071 29.7891 3.33579 30.1642C3.71086 30.5393 4.21957 30.75 4.75 30.75H26.75C27.2804 30.75 27.7891 30.5393 28.1642 30.1642C28.5393 29.7891 28.75 29.2804 28.75 28.75V14.75Z",
    stroke: "#EEB111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 8.75H2.75C2.21957 8.75 1.71086 8.96071 1.33579 9.33579C0.960714 9.71086 0.75 10.2196 0.75 10.75V13.75C0.75 14.0152 0.855357 14.2696 1.04289 14.4571C1.23043 14.6446 1.48478 14.75 1.75 14.75H29.75C30.0152 14.75 30.2696 14.6446 30.4571 14.4571C30.6446 14.2696 30.75 14.0152 30.75 13.75V10.75C30.75 10.2196 30.5393 9.71086 30.1642 9.33579C29.7891 8.96071 29.2804 8.75 28.75 8.75Z",
    stroke: "#EEB111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 8.75C10.3313 8.75 5.75 5.16867 5.75 0.75",
    stroke: "#EEB111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 0.75C10.1687 0.75 14.75 4.33133 14.75 8.75",
    stroke: "#EEB111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 8.75C21.1687 8.75 25.75 5.16867 25.75 0.75",
    stroke: "#EEB111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 0.75C21.3313 0.75 16.75 4.33133 16.75 8.75",
    stroke: "#EEB111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 8.75H12.75V30.75H18.75V8.75Z",
    stroke: "#EEB111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhirlpoolStepperReviewIcon);
export default __webpack_public_path__ + "static/media/whirlpool-stepper-review-icon.0699406b61eabda3c88d3cb61d510df5.svg";
export { ForwardRef as ReactComponent };